import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function shortenParahrap(parahrap: string): string {
  const words: Array<string> = parahrap.split(" ");
  return `${words.slice(0, 20).join(" ")}...`;
}
